<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
           <template>
              <b-row>
                <b-col lg="12" sm="12" class="text-center mb-3">
                  <h5 class='complain-title'>{{ $t('production_store.raw_material_purchase_receive') }}</h5>
                </b-col>
              </b-row>
                <b-row>
                  <b-col lg="12" sm="12">
                    <b-row>
                      <b-col lg="12" sm="12">
                        <b-table-simple striped bordered small>
                          <b-tr>
                            <b-th width="200px">{{ $t('production_store.purchase_order_id') }}</b-th>
                            <b-td width="200px">{{ formData.purchase_order_id }}</b-td>
                            <b-th width="200px">{{ $t('production_store.receive_id') }}</b-th>
                            <b-td width="200px">{{ formData.receive_id }}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-th >{{ $t('production_store.purchase_date') }}</b-th>
                            <b-td>{{ formData.purchase_date | dateFormat }}</b-td>
                            <b-th >{{ $t('production_store.receive_date') }}</b-th>
                            <b-td>{{ formData.receive_date | dateFormat }}</b-td>
                          </b-tr>
                          <b-tr>
                            <b-th >{{ $t('production_store.purchase_memo_no') }}</b-th>
                            <b-td>{{ formData.memo_no }}</b-td>
                            <b-th >{{ $t('production_store.supplier_name') }}</b-th>
                            <b-td>{{ supplierNameById(formData.purchase.supplier_id) }}</b-td>
                          </b-tr>
                        </b-table-simple>
                      </b-col>
                      <b-col lg="12" sm="12" class="text-center mb-3">
                        <h5 class='complain-title'>{{ $t('production_store.product_list') }}</h5>
                      </b-col>
                      <b-col>
                        <table class="table table-bordered">
                            <tr class="bg-light">
                                <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                <th>{{ $t('production_store.pro_category') }}</th>
                                <th>{{ $t('production_store.pro_sub_category') }}</th>
                                <th>{{ $t('production_store.pro_name') }}</th>
                                <th>{{ $t('production_store.pro_unit') }}</th>
                                <th>{{ $t('production_store.unit_price') }}</th>
                                <th>{{ $t('production_store.purchase_quantity') }}</th>
                                <th>{{ $t('production_store.receive_quantity') }}</th>
                                <th>{{ $t('production_store.total_price') }}</th>
                            </tr>
                            <tr v-for="(item, index) in formData.rec_details" :key="index">
                                <td>{{ $n(index + 1) }}</td>
                                <td>{{ productCategoryById(item.category_id) }}</td>
                                <td v-if="item.sub_category_id">{{ productSubCategoryById(item.sub_category_id) }}</td>
                                <td v-else></td>
                                <td>{{ productNameById(item.product_id) }}</td>
                                <td>{{ unitNameById(item.unit_id) }}</td>
                                <td>{{ $n(item.unit_price) }}</td>
                                <td>{{ $n(item.purchase_qty) }}</td>
                                <td>{{ $n(item.receive_qty) }}</td>
                                <td>{{ $n(item.total_price) }}</td>
                            </tr>
                        </table>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: ['id'],
  data () {
    return {
      formData: {
        rec_details: []
      }
    }
  },
  computed: {
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  created () {
    if (this.id) {
      const tmp = this.getProductData()
      this.formData = tmp
    }
  },
  methods: {
    getProductData () {
      const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
      const data = JSON.parse(JSON.stringify(tmpData))
      const ferDetails = data.rec_details.map(item => {
        return Object.assign(item, item.product)
      })
      return Object.assign(data, ferDetails)
    },
    productNameById (id) {
        const product = this.productCommonObj.productList.find(product => product.value === id)
        if (this.$i18n.locale === 'bn') {
            return product.text_bn
        } else {
            return product.text_en
        }
    },
    unitNameById (id) {
        const unit = this.productCommonObj.productUnitList.find(unit => unit.value === id)
        if (this.$i18n.locale === 'bn') {
            return unit.text_bn
        } else {
            return unit.text_en
        }
    },
    productCategoryById (id) {
      const category = this.productCommonObj.productCategoryList.find(category => category.value === id)
      if (this.$i18n.locale === 'bn') {
          return category.text_bn
      } else {
          return category.text_en
      }
    },
    productSubCategoryById (id) {
      const subCategory = this.productCommonObj.productSubCategoryList.find(subCategory => subCategory.value === id)
      if (this.$i18n.locale === 'bn') {
          return subCategory.text_bn
      } else {
          return subCategory.text_en
      }
    },
    supplierNameById (supplierId) {
      const company = this.productCommonObj.supplierInfoList.find(item => item.value === supplierId)
        if (this.$i18n.locale === 'bn') {
            return company.text_bn
        } else {
            return company.text_en
        }
    }
  }
}
</script>
